module.exports = __webpack_public_path__ + "img/layout_03_default.0956cb3c.svg";